import React from "react";
import { ReactComponent as WarningSvg } from "../svgs/warning.svg";
import { ReactComponent as ErrorSvg } from "../svgs/error.svg";
import { ReactComponent as EscalatedSvg } from "../svgs/escalated.svg";

const REJECTION_CONFIG = {
  hazardous: {
    message:
      "This item has been marked as hazardous. Proceed with caution when handling.",
    backgroundColor: "rgb(254, 243, 199)", // Yellow-50
    textColor: "rgb(113, 63, 18)", // Yellow-900
    icon: WarningSvg,
  },
  fraudulent: {
    message:
      "This item has been marked as fraudulent. Handle according to fraud protocols.",
    backgroundColor: "rgb(254, 226, 226)", // Red-100
    textColor: "rgb(127, 29, 29)", // Red-900
    icon: ErrorSvg,
  },
  escalated: {
    message: "This item has been escalated. Follow escalation procedures.",
    backgroundColor: "rgb(254, 226, 226)", // Red-100
    textColor: "rgb(127, 29, 29)", // Red-900
    icon: EscalatedSvg,
  },
  other: {
    message: "This item has been flagged for review. Check notes for details.",
    backgroundColor: "rgb(219, 234, 254)", // Blue-100
    textColor: "rgb(30, 58, 138)", // Blue-900
    icon: null,
  },
};

export const RejectedBanner = ({ rejectCategory }) => {
  const config = REJECTION_CONFIG[rejectCategory] || REJECTION_CONFIG.other;
  const Icon = config.icon;

  return (
    <div
      className="flex items-center justify-center px-6 py-3 gap-2.5"
      style={{ backgroundColor: config.backgroundColor }}
    >
      {Icon && <Icon className="w-6 h-6" style={{ fill: config.textColor }} />}
      <p
        className="text-base font-medium leading-[1.3125]"
        style={{ color: config.textColor }}
      >
        {config.message}
      </p>
    </div>
  );
};
